<template>
  <div>
    <b-card title="Summary">
        <div class="m-2" v-for="cart in carts" :key="cart.id">
            <SummaryList :cart="cart"/>
        </div>
        <b-row>
            <b-col class="text-success"><strong>Total: ${{ getTotal }}</strong></b-col>
            <b-col class="text-right"><button class="btn-sm btn-primary" @click="checkout"><b-icon-truck/> Checkout</button></b-col>
        </b-row>
    </b-card>
    </div>
</template>

<script>
import SummaryList from '@/components/SummaryList.vue'

export default {
  name: 'Summary',
  components: {
    SummaryList
  },
  props: ['carts'],
  computed: {
    getTotal () {
      let total = 0
      this.carts.forEach(cart => {
        total += cart.qty * cart.Product.price
      })
      return total
    }
  },
  methods: {
    checkout () {
      const payload = {
        data: this.carts
      }
      this.$store.dispatch('checkout', payload)
      this.$store.commit('setTotalCash', this.getTotal)
      this.$router.push({ name: 'Checkout' })
    }
  }
}
</script>

<style>

</style>
